import React from 'react';

export const AppsRemainingContext = React.createContext({
	count: 0,
	decrementCount: () => {},
	minionCount: 0,
	decrementMinionCount: () => {},
});
